/* eslint-disable arrow-parens */
import englishMessages from 'shared/translations/en.json';
import arabMessages from 'shared/translations/ar.json';
import moment from 'moment';
import enLocale from 'moment/locale/fr';
import arLocale from 'moment/locale/ar';

import { getFormOptions } from 'shared/store/actions';
import apiRequest from 'shared/services/api';
import { ACTION_TYPE } from './actionTypes';


// export const switchLanguage = id => (dispatch) => {
//   const languages = {
//     EN: englishMessages,
//     AR: arabMessages,
//   };

//   const payload = { language: { locale: id, messages: languages[id] } };
//   dispatch({
//     type: ACTION_TYPE.SWITCH_LANGUAGE,
//     payload,
//   });
// };

export const storeTranslation = intl => (dispatch, getState) => {
  const { language } = getState().languageReducer;
  const translation = {
    EN: { ...intl.EN, ...englishMessages },
    AR: { ...intl.AR, ...arabMessages },
  };

  moment.locale(language.locale, enLocale);

  dispatch({
    type: ACTION_TYPE.STORE_TRANSLATION,
    payload: {
      translation,
      messages: { // messages for default locale
        [language.locale]: { ...translation[language.locale] },
      },
    },
  });
};

export const switchLanguage = () => async (dispatch, getState) => {
  const { language, translation } = getState().languageReducer;
  let locale;
  if (language.locale === 'EN') {
    locale = 'AR';
    moment.locale('AR', arLocale);
  } else {
    locale = 'EN';
    moment.locale('EN', enLocale);
  }

  dispatch({
    type: ACTION_TYPE.SWITCH_LANGUAGE,
    payload: {
      locale,
      messages: { [locale]: translation[locale] },
    },
  });
};

export const changeLanguageBasedOnParam = (locale) => async (dispatch, getState) => {
  const { translation } = getState().languageReducer;
  if (locale === 'en') {
    locale = 'EN';
    moment.locale('EN', enLocale);
  } else {
    locale = 'AR';
    moment.locale('AR', arLocale);
  }

  dispatch({
    type: ACTION_TYPE.SWITCH_LANGUAGE,
    payload: {
      locale,
      messages: { [locale]: translation[locale] },
    },
  });
}

const geti18nFail = error => ({
  type: ACTION_TYPE.STORE_TRANSLATION_FAIL,
  payload: { error },
});

export const geti18n = () => async (dispatch, getState) => {
  const { token } = getState().authReducer;
  await dispatch(getFormOptions(token));
  try {
    const messages = await apiRequest.getIntl(token);
    if (Object.keys(messages).length) dispatch(storeTranslation(messages));
  } catch (err) {
    dispatch(geti18nFail(err));
  }
};

// export default switchLanguage;
